// components/UI/CustomSlider.js
import React, { useState, useEffect } from 'react';

const CustomSlider = ({ 
  value, 
  onChange, 
  min = 0, 
  max = 100, 
  step = 1,
  label,
  showValue = true,
  valueFormatter = (val) => `${Math.round(val)}%`,
  className = "",
  onSliderStart,
  onSliderEnd,
  ...props 
}) => {
  const [localValue, setLocalValue] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  // Use local value during dragging, otherwise use prop value
  const displayValue = isDragging && localValue !== null ? localValue : value;

  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    setLocalValue(newValue);
    onChange(newValue);
  };

  const handleMouseDown = () => {
    setIsDragging(true);
    setLocalValue(value);
    if (onSliderStart) {
      onSliderStart();
    }
  };

  const handleMouseUp = (e) => {
    e.currentTarget.blur()
    setIsDragging(false);
    setLocalValue(null);
    if (onSliderEnd) {
      onSliderEnd();
    }
  };

  // Reset local state if external value changes while not dragging
  useEffect(() => {
    if (!isDragging) {
      setLocalValue(null);
    }
  }, [value, isDragging]);

  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-xs font-medium text-white mb-1">
          {label}
        </label>
      )}
      <div className="flex items-center space-x-2">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={displayValue}
          onChange={handleChange}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onTouchStart={handleMouseDown}
          onTouchEnd={handleMouseUp}
          className={`w-full h-2 rounded-lg appearance-none cursor-pointer bg-ag-black-600 accent-ag-green ${className}`}
          {...props}
        />
        {showValue && (
          <span className="text-xs text-white w-8">
            {valueFormatter(displayValue)}
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomSlider;